const configureTrackJs = (userId: string | null | undefined) => {
  if (window.trackJs) {
    if (userId) {
      window.trackJs.configure({
        userId,
      });
    }
    const applicationContext = window.navigator.userAgent.includes(
      'Idealist Mobile App iOS',
    )
      ? 'ios'
      : 'web';
    window.trackJs.addMetadata('applicationContext', applicationContext);
  }
};

// eslint-disable-next-line import/no-default-export
export default configureTrackJs;
